import { fetchAuthSession } from 'aws-amplify/auth';

/**
 * Link-out rules for YOYO Picks (docs/prd-homepage-redesign.md §5.7): the provider
 * link gets our utm tags, and each link-out or calendar choice is counted.
 */

/** Adds utm_source=sayyoyo&utm_medium=picks, keeping any query and hash already there. */
export function withPicksUtm(rawUrl: string): string {
  try {
    const url = new URL(rawUrl);
    url.searchParams.set('utm_source', 'sayyoyo');
    url.searchParams.set('utm_medium', 'picks');
    return url.toString();
  } catch {
    // Not a valid absolute URL: leave it as is rather than break the button.
    return rawUrl;
  }
}

/**
 * Records a LINK or CALENDAR click without holding up the visitor: fire and forget,
 * `keepalive` so it survives the page going away, failures ignored.
 */
export async function logPickClick(pickId: string, kind: 'LINK' | 'CALENDAR'): Promise<void> {
  try {
    let token: string | undefined;
    try {
      token = (await fetchAuthSession()).tokens?.idToken?.toString();
    } catch {
      token = undefined; // signed out: counted as a visitor
    }
    const api = import.meta.env.VITE_API_URL || 'http://localhost:3000/api/v1';
    await fetch(`${api}/picks/${encodeURIComponent(pickId)}/click`, {
      method: 'POST',
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ kind }),
    });
  } catch {
    // Counting must never get in the way of the visitor.
  }
}
